import { ReactNode } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  onAccept?: () => void;
  closeLabel?: string;
  acceptLabel?: string;
  acceptDisabled?: boolean;
  children: ReactNode;
}

export const ConfirmationDialog = ({
  open,
  title,
  onClose,
  onAccept,
  closeLabel = "Cerrar",
  acceptLabel = "Acepto",
  acceptDisabled = false,
  children,
}: Props) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: "16px" } }}>
    <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", px: 3, py: 2 }}>
      <Typography variant="h6" fontWeight={700}>
        {title}
      </Typography>
      <IconButton size="small" onClick={onClose} sx={{ mt: -0.5, mr: -1 }}>
        <Close fontSize="small" />
      </IconButton>
    </Box>

    <Divider />

    <DialogContent
      sx={{
        px: 3,
        pt: 1,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        "& .MuiTypography-root": { textAlign: "left !important" },
      }}
    >
      {children}
    </DialogContent>

    <Divider />

    <DialogActions sx={{ px: 3, py: 1, backgroundColor: "#F4F6F9" }}>
      <Button
        variant="outlined"
        size="small"
        onClick={onClose}
        sx={{ width: "100px", height: "36px", fontSize: "body2.fontSize" }}
      >
        {closeLabel}
      </Button>
      <Button
        variant="contained"
        onClick={onAccept ?? onClose}
        disabled={acceptDisabled}
        sx={{ minWidth: "100px", height: "36px", fontSize: "body2.fontSize" }}
      >
        {acceptLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
